
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource-center",
      function () {
        return require("private-next-pages/resource-center/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource-center"])
      });
    }
  